import { render } from "./Color.vue?vue&type=template&id=4a963abc&scoped=true"
import script from "./Color.vue?vue&type=script&lang=ts"
export * from "./Color.vue?vue&type=script&lang=ts"

import "./Color.vue?vue&type=style&index=0&id=4a963abc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a963abc"

export default script